import {useMemo} from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  RouteObject,
} from 'react-router-dom';
import {useFeatureFlag} from '../lib/feature-flags-context';
import {FEATURE_FLAG_KEYS} from '../../../shared/feature-flags';
import {legacyRoutes} from '../../router';
import {
  newPlgRouteChildren,
  releasedPlgRoutes,
  viewPlansRoutes,
} from './new-routes';

type RouteConfig = RouteObject[];

export const AppRouter = () => {
  const disableBillingView = useFeatureFlag(
    FEATURE_FLAG_KEYS.DISABLE_BILLING_VIEW,
    false
  );

  const mergedRouter = useMemo(() => {
    const routes: RouteConfig = [
      ...legacyRoutes,
      ...releasedPlgRoutes,
      ...(newPlgRouteChildren as RouteConfig),
    ];

    if (disableBillingView) {
      routes.push(...(viewPlansRoutes as RouteConfig));
    }

    return createBrowserRouter(routes);
  }, [disableBillingView]);

  return <RouterProvider router={mergedRouter} />;
};
